import { render, staticRenderFns } from "./WhatsappMsgSection.vue?vue&type=template&id=fbd1d6e6&"
import script from "./WhatsappMsgSection.vue?vue&type=script&lang=js&"
export * from "./WhatsappMsgSection.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappMsgSection.vue?vue&type=style&index=0&id=fbd1d6e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports